import React from 'react'
import PropTypes from 'react-proptypes'
import styled from 'styled-components'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import { CurrenciesIcon } from 'assets/currencies'
import { withTheme } from 'material-ui/styles'
import compose from 'recompose/compose'

const FONT_SIZE_NORMAL = 20
class Legend extends React.Component {
  render = () => {
    const { radius, colour, theme, highlightedCurrencies } = this.props
    const Circle = ({ color = 'white' }) => (
      <circle
        r={radius * 0.3}
        style={{
          fill: color,
          fillOpacity: 0.1,
        }}
      />
    )

    const Root = styled.g`
      transform-style: preserve-3d;
      position: relative;
      perspective: 1000px;
    `
    return (
      <Root className="legend">
        <Circle
          color={
            highlightedCurrencies.length > 0
              ? colour(highlightedCurrencies[0])
              : undefined
          }
        />
        {highlightedCurrencies.length > 1 && (
          <text
            style={{
              textAnchor: 'middle',
              fontSize: FONT_SIZE_NORMAL,
              fill: 'currentColor',
            }}
          >
            <tspan x="0">
              {highlightedCurrencies.slice(0, 3).join(', ')}
              {highlightedCurrencies.length > 3 && '...'}
            </tspan>
          </text>
        )}
        {highlightedCurrencies.length === 1 && (
          <g transform="translate(0, 90)">
            <circle r={60} fill={theme.palette.background.default} cy={-95} />
            <CurrenciesIcon
              currency={highlightedCurrencies[0]}
              width={100}
              fill={colour(highlightedCurrencies[0])}
              height={100}
              x={-50}
              y={-145}
            />
          </g>
        )}
      </Root>
    )
  }
}
Legend.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.number.isRequired,
  colour: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
  highlightedCurrencies: PropTypes.array,
  mainCurrency: PropTypes.string,
}
const mapStateToProps = state => ({
  highlightedCurrencies: selectors.highlightedCurrencies(state),
})
export default compose(withTheme(), connect(mapStateToProps))(Legend)



// WEBPACK FOOTER //
// ./src/components/Donut/Legend.js